// MyGet namespace
(function (myget, $) {
    // String extensions
    String.prototype.trimStart = function (c) {
        if (this.length == 0)
            return this;
        c = c ? c : ' ';
        var i = 0;
        var val = 0;
        for (; this.charAt(i) == c && i < this.length; i++);
        return this.substring(i);
    };
    String.prototype.trimEnd = function (c) {
        c = c ? c : ' ';
        var i = this.length - 1;
        for (; i >= 0 && this.charAt(i) == c; i--);
        return this.substring(0, i + 1);
    };
    String.prototype.trim = function (c) {
        return this.trimStart(c).trimEnd(c);
    };
    String.prototype.summary = function (l) {
        if (this.length <= l) {
            return this;
        }
        return this.substr(0, l) + '...';
    };
    
    // Helper functions
    function elementInViewport(el) {
        var position = el.position();
        var width = el.width();
        var height = el.height();

        if (position && width && height) {
            return position.left >= 0
                && position.top >= 0
                && (position.top + height) <= window.innerHeight
                && (position.left + width) <= window.innerWidth;
        }
        return false; // element not found
    }

    function sniffIE() {
        var ua = window.navigator.userAgent;

        var msie = ua.indexOf('MSIE ');

        if (msie > 0) {
            // IE 10 or older => return version number  
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number  
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        // other browser or edge  
        return false;
    }

    // Is IE?
    myget.isIE = sniffIE();
    
    // Startup
    $(function () {
        // Add AntiForgeryToken data to ajax calls
        $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
            var method = options.type.toUpperCase();
            if (method === "POST" || method === "PUT" || method === "DELETE") {
                var token = $("#_AntiForgeryForm input[name^=__RequestVerificationToken]").first();
                if (!token.length) return;

                var tokenValue = token.attr("value");

                jqXHR.setRequestHeader('X-RequestVerificationToken', tokenValue);
            }
        });

        // Focus first element
        var firstInputTextElement = $("input[type='text']:first");
        if (firstInputTextElement && elementInViewport(firstInputTextElement)) {
            firstInputTextElement.focus();
        }
        
        // Style highlightable list items
        $('.highlightable input[type=radio]').change(function () {
            $('.highlightable input[type=radio]').each(function () {
                $(this).closest('li').removeClass('highlighted');
            });
            $(this).closest('li').addClass('highlighted');
        });

        // Set XEditable default mode to inline mode
        $.fn.editable.defaults.mode = 'inline';

        // Handle "read-more" expansion
        $(".read-more .read-more-expand a").click(function () {
            var totalHeight = $(".read-more .read-more-expand").outerHeight() / 2;

            var $el = $(this);
            var $p = $el.parent();
            var $up = $p.parent();
            var $ps = $up.find(".read-more-content");

            // measure how tall inside should be by adding together heights of all inside paragraphs (except read-more paragraph)
            $ps.each(function () {
                totalHeight += $(this).outerHeight();
            });

            $up
              .css({
                  // Set height to prevent instant jumpdown when max height is removed
                  "height": $up.height(),
                  "max-height": 9999
              })
              .animate({
                  "height": totalHeight
              });

            // fade out read-more
            $p.fadeOut();

            // prevent jump-down
            return false;
        });

        $(".read-more").each(function(i, item) {
            var totalHeight = $(item).outerHeight();
            if (totalHeight < 300) {
                // expand if we have the right height
                $(item).find(".read-more-expand a").click();
            }
        });
    });

    // Clipboard
    //   use execCommand copy and a dynamic textarea as source for the text  
    //   requestingElement is used as the parent for the dynamic textarea, otherwise  
    //   MS Edge might "jump" to the newly created item if you append it as child of the body  
    myget.copyToClipboard = function(text, requestingElement)
    {
        if (myget.isIE) {
            try {
                window.clipboardData.setData('Text', text);
            } catch (err) {
                console.log('Unable to copy to clipboard via IE-setData.');
            }
        } else {
            var textField = document.createElement('textarea');
            textField.style.position = 'fixed';
            textField.style.top = 0;
            textField.style.left = 0;
            textField.style.width = '2em';
            textField.style.height = '2em';
            textField.style.padding = 0;
            textField.style.border = 'none';
            textField.style.outline = 'none';
            textField.style.boxShadow = 'none';
            textField.style.background = 'transparent';
            textField.value = text;

            requestingElement.appendChild(textField);

            textField.focus();
            textField.select();

            try {
                document.execCommand('copy');
            } catch (err) {
                console.log('Unable to copy to clipboard.');
            }

            requestingElement.removeChild(textField);
        }
    };

    // reveal
    myget.reveal = function ($element, value, placeholder) {
        $element.data('reveal', value);
        $element.click(function (e) {
            $(this).val($(this).data('reveal'));
        });

        $element.val(placeholder
            ? placeholder
            : '<hidden - click to show>');
    }
    
    // waitForRemoteValidation
    myget.waitForRemoteValidation = function (interval, callback) {
        var innerFunction = function () {
            if ($.active <= 0) {
                callback();
            } else {
                setTimeout(function () { innerFunction(interval, callback); }, interval);
            }
        };

        setTimeout(function () { innerFunction(interval, callback); }, interval);
    };

    // invokeWithDelay
    var timeout = null;
    myget.invokeWithDelay = function(delay, callback) {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(callback, delay);
    }

    // Popup
    myget.popupWindow = function (url, title, width, height) {
        var left = (screen.width - width) / 2;
        var top = (screen.height - height) / 2 - 50;

        return window.open(url, 'myget', "toolbar=no,menubar=no,scrollbars=yes,statusbar=no,height=" + height + ",width=" + width + ",left=" + left + ",top=" + top + "");
    };
    
    // Partial dialog
    myget.partialDialog = {
        show: function (options) {
            // Default options
            var defaults = {
                title: 'Dialog',
                saveLabel: 'Save',
                cancelLabel: 'Cancel',
                bodyCssClass: '',
                width: 600,
                height: 540,
                onSave: false,
                onCancel: false,
                waitForRemoteValidation: false,
                cssclass: ''
            };
            options = $.extend({}, defaults, options);
            
            // Hack on Bootstrap
            var innerHeight = options.height - 140;

            // Create dialog
            var left = '';
            if (options.width != '') {
                left = 'left:' + ((($(window).width() - options.width) / 2) + 280) + 'px;';
            }
            var dialog = $('<div class="modal hide fade ' + options.cssclass + '" tabindex="-1" role="dialog" style="' + left + ' width: ' + options.width + 'px; height: ' + options.height + 'px;"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" class="closeButton">x</button><h3>' + options.title + '</h3></div><div class="modal-body ' + options.bodyCssClass + '" style="height: ' + innerHeight + 'px; max-height: ' + innerHeight + 'px;"></div><div class="modal-footer"><button class="btn closeButton" data-dismiss="modal" aria-hidden="true">' + options.cancelLabel + '</button>' + (options.saveLabel != '' ? '<button class="btn btn-success saveButton" type="submit">' + options.saveLabel + '</button>' : '') + '</div></div>').appendTo('body');
            var url = options.url;
            if (url.indexOf('?') >= 0) {
                url += '&salt=' + (new Date()).getTime();
            } else {
                url += '?salt=' + (new Date()).getTime();
            }

            jQuery.isReady = false;
            $('<div />').load(url, function () {
                // Inject data
                if ($.fn.MultiFile !== undefined) {
                    for (var method in $.fn.MultiFile.intercepted) {
                        $.fn[method] = $.fn.MultiFile.intercepted[method];
                    }
                }

                $.fn.MultiFile = undefined;
                dialog.find(".modal-body").html($(this).find('.partial').html());

                // Wire buttons
                dialog.find('.closeButton').click(function (e) {
                    if (options.onCancel) {
                        options.onCancel();
                    }
                    dialog.modal('hide');
                });

                dialog.on("hide.bs.modal", function () {
                    $('#ajaxActivity').hide();
                });

                dialog.find('.saveButton').click(function(e) {
                    var form = dialog.find(".modal-body").find('form:first');
                    var tabs = [];
                    
                    // if we are on jQuery UI tabs, find the form from the active tab
                    tabs = dialog.find(".modal-body").find('.ui-tabs:first');
                    if (tabs.length > 0) {
                        form = $(".ui-tabs:first").find(".ui-tabs-panel:visible").find("form:first");
                    }
                    
                    // if we are on bootstrap tabs, find the form from the active tab
                    tabs = dialog.find('.tab-pane');
                    if (tabs.length > 0) {
                        form = dialog.find(".modal-body").find('.tab-pane.active').find("form:first");
                    }

                    $.validator.unobtrusive.parse(form);
                    if ($(form).valid()) {
                        var completionFunction = function() {
                            if ($(form).valid()) {
                                if (options.onSave) {
                                    options.onSave($(form));
                                    dialog.modal('hide');
                                } else {
                                    $(form).submit();
                                }
                            }
                        };
                        if (options.waitForRemoteValidation) {
                            myget.waitForRemoteValidation(250, completionFunction);
                        } else {
                            completionFunction();
                        }
                    }
                });
                
                // Wire HTML
                if (options.title == "Add package") {
                    if (dialog.find("input[type='submit']")) {
                        $(":button:contains('" + options.saveLabel + "')").attr('disabled', 'disabled');
                    }
                }

                dialog.find("input[type='text']:first").focus();
                dialog.find("input[type='submit']").remove();

                // Show it!
                dialog.modal('show').on('hidden', function () {
                    $(this).remove(); // clean up our DOM node
                });
                setTimeout(function () {
                    // Run loaded scripts
                    var reponseScript = dialog.find(".modal-body").filter('script');
                    $.each(reponseScript, function (idx, val) { eval(val.text); });
                    jQuery.ready(false);

                    // UI updates
                    dialog.find(".modal-body").find('input[type=text]:first').focus();
                    bootstrapValidation();
                }, 800);
            });
        }
    };
}(this.myget = this.myget || {}, jQuery));
